const toBase64 = (file: File) => new Promise<string | ArrayBuffer>((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

export default toBase64;
